/* Joe Luxe "Made to meet" set showroom — swipe engine.
   Native scroll-snap does the swiping. This script only:
   - tracks which set is on screen (counter, arrows, hint),
   - plays the landing (--land 0 → 1, ~1s, smoothstep) when a new set arrives.
   CSS multiplies --land by the page-scroll progress --p (from joe-luxe.js), so the
   set on screen always stays synced to scrolling up and down.
   Transform/opacity only; idle when nothing moves. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 1000;

  function ease(t) {
    return t * t * (3 - 2 * t);
  }

  function setup(root) {
    var track = root.querySelector('[data-jl-mc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-jl-mc-slide]'));
    var current = root.querySelector('[data-jl-mc-current]');
    var prev = root.querySelector('[data-jl-mc-prev]');
    var next = root.querySelector('[data-jl-mc-next]');
    if (!track || !slides.length) return;

    var active = 0;
    var swiped = false;
    var anims = new Map();

    function play(slide) {
      if (reduce) {
        slide.style.setProperty('--land', '1');
        return;
      }
      var start = null;
      var id = {};
      anims.set(slide, id);
      slide.style.setProperty('--land', '0');
      function step(ts) {
        if (anims.get(slide) !== id) return;
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / DURATION);
        slide.style.setProperty('--land', ease(t).toFixed(4));
        if (t < 1) window.requestAnimationFrame(step);
        else anims.delete(slide);
      }
      window.requestAnimationFrame(step);
    }

    function setActive(i) {
      if (i === active) return;
      active = i;
      if (current) current.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      if (!swiped) {
        swiped = true;
        root.classList.add('is-swiped');
      }
      play(slides[i]);
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var i = slides.indexOf(e.target);
          if (e.intersectionRatio >= 0.6) {
            setActive(i);
          } else if (e.intersectionRatio === 0 && swiped) {
            /* off screen: reset so it assembles again when it returns */
            anims.delete(e.target);
            e.target.style.setProperty('--land', '0');
          }
        });
      },
      { root: track, threshold: [0, 0.6] }
    );
    slides.forEach(function (s) {
      io.observe(s);
    });

    function go(dir) {
      var i = Math.max(0, Math.min(slides.length - 1, active + dir));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-jl-mc]'), setup);
})();
